export default "__VITE_ASSET__sk_R22Qt__"